export const DEFAULT_AUTH_API_VERSION = 'v1'

export const ENDPOINT_AUTH_LOGIN_OPTIONS = `/api/auth/*/login/options`
export const ENDPOINT_AUTH_LOGIN_PASSWORD = `/api/auth/*/login/password`
export const ENDPOINT_AUTH_LOGIN_PIN = `/api/auth/*/login/pin`
export const ENDPOINT_AUTH_LOGIN_TOKEN_EXTERNAL = `/api/auth/*/login/token_external`
export const ENDPOINT_AUTH_MFA_SETUP_INITIATE = `/api/auth/*/mfa/setup-initiate`
export const ENDPOINT_AUTH_MFA_SETUP_VERIFY = `/api/auth/*/mfa/setup-verify`
export const ENDPOINT_AUTH_MFA_VERIFY = `/api/auth/*/mfa/verify`
export const ENDPOINT_AUTH_MFA_DISABLE = `/api/auth/*/clinics/*/mfa/disable`
export const ENDPOINT_AUTH_MFA_SELF_DISABLE = `/api/auth/*/mfa/self_disable`
export const ENDPOINT_AUTH_TOKEN_EXCHANGE = `/api/auth/*/token/exchange`
export const ENDPOINT_AUTH_TOKEN_REFRESH = `/api/auth/*/token/refresh`
export const ENDPOINT_AUTH_TOKEN_REVOKE = `/api/auth/*/token/revoke`
export const ENDPOINT_AUTH_MANAGEMENT_FORGOT_PASSWORD = `/api/auth/*/management/forgot_password`
export const ENDPOINT_AUTH_MANAGEMENT_CHANGE_PASSWORD = `/api/auth/*/management/change_password`
